import { render } from "./DomainShopItem.vue?vue&type=template&id=177bac48&scoped=true"
import script from "./DomainShopItem.vue?vue&type=script&lang=js"
export * from "./DomainShopItem.vue?vue&type=script&lang=js"

import "./DomainShopItem.vue?vue&type=style&index=0&id=177bac48&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177bac48"]])

export default __exports__